import { createContext, useReducer, useEffect } from "react";
import Cookies from "js-cookie";
import AuthReducer from "./AuthReducer";
import { accountService } from "../services/api/accountService";

const safeEncode = (str) => btoa(encodeURIComponent(str));
const safeDecode = (str) => decodeURIComponent(atob(str));

const INITIAL_STATE = {
  token: Cookies.get("token") || null,
  refreshToken: Cookies.get("refreshToken") || null,
  user: Cookies.get("user")
    ? JSON.parse(safeDecode(Cookies.get("user")))
    : null,
};

export const AuthContext = createContext(INITIAL_STATE);

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

  useEffect(() => {
    if (state.token) {
      Cookies.set("token", state.token, { expires: 7 });
    } else {
      Cookies.remove("token");
    }

    if (state.refreshToken) {
      Cookies.set("refreshToken", state.refreshToken, { expires: 30 });
    } else {
      Cookies.remove("refreshToken");
    }

    if (state.user) {
      Cookies.set("user", safeEncode(JSON.stringify(state.user)), {
        expires: 7,
      });
    } else {
      Cookies.remove("user");
    }
  }, [state.token, state.refreshToken, state.user]);

  // Kiểm tra phiên làm việc khi khởi chạy
  useEffect(() => {
    const verifySession = async () => {
      if (state.token) {
        try {
          await accountService.get_me(state.token);
        } catch (error) {
          console.error("Session verification failed:", error);
          if (error.response?.status === 401) {
            dispatch({ type: "LOGOUT" });
          }
        }
      }
    };

    verifySession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Lắng nghe event refresh token
  useEffect(() => {
    const handleTokenRefresh = (event) => {
      const { token, refreshToken } = event.detail;

      dispatch({
        type: "REFRESH_TOKEN",
        payload: {
          token: token,
          refreshToken: refreshToken,
        },
      });
    };

    window.addEventListener("tokenRefreshed", handleTokenRefresh);

    return () => {
      window.removeEventListener("tokenRefreshed", handleTokenRefresh);
    };
  }, []);

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        refreshToken: state.refreshToken,
        user: state.user,
        dispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
